module.exports = __webpack_public_path__ + "img/dhfesta_productInfo_0411.78e72054.jpg";